module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.headerShow) ? _c('header', [_c('div', {
    staticClass: "header"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('h1', {
    staticClass: "left r2logo"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "left"
  }, [_c('li', {
    class: {
      current: 1 == _vm.currentNum
    },
    on: {
      "click": function($event) {
        return _vm.navClick(1)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "r2list right"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "top-gameBox cd"
  }, [_c('p', {
    staticClass: "top-ad"
  }), _vm._v(" "), _c('div', {
    staticClass: "top-lst"
  }, [_c('div', {
    staticClass: "m-topGame"
  }, [_c('h2', {
    staticClass: "title web-title"
  }, [_vm._v("手机游戏")]), _vm._v(" "), _c('ul', {
    staticClass: "u-gameLst cd"
  }, _vm._l((_vm.list), function(i, index) {
    return _c('li', {
      key: index
    }, [(i.url) ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": i.url
      }
    }, [_c('span', [_vm._v(_vm._s(i.title))]), _vm._v(" "), _c('i', {
      staticClass: "icon",
      class: {
        'hot': i.type2 == 1, 'new': i.type2 == 2
      }
    })]) : _vm._e(), _vm._v(" "), (!i.url) ? _c('a', {
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.onMassageChange('敬请期待')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(i.title))]), _vm._v(" "), _c('i', {
      staticClass: "icon",
      class: {
        'hot': i.type2 == 1, 'new': i.type2 == 2
      }
    })]) : _vm._e()])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "header-login",
    attrs: {
      "id": "toploginForm"
    }
  }, [(_vm.isLogin) ? _c('router-link', {
    staticClass: "login",
    attrs: {
      "to": "/personage"
    }
  }, [_vm._v(_vm._s(_vm.isLogin))]) : _vm._e(), _vm._v(" "), (!_vm.isLogin) ? _c('a', {
    attrs: {
      "title": "登录"
    },
    on: {
      "click": function($event) {
        return _vm.popUpWindow('登录')
      }
    }
  }, [_vm._v("登录")]) : _vm._e(), _vm._v(" |\n        "), (!_vm.isLogin) ? _c('a', {
    attrs: {
      "title": "注册"
    },
    on: {
      "click": function($event) {
        return _vm.popUpWindow('快速注册')
      }
    }
  }, [_vm._v("注册")]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('a', {
    attrs: {
      "title": "注销"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("注销")]) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.currentNum != 1) ? _c('Vfooter') : _vm._e(), _vm._v(" "), _c('Vjoin', {
    attrs: {
      "webpopUp": _vm.popUp
    },
    on: {
      "on-popUp-change": _vm.onPopUpChange
    }
  }), _vm._v(" "), _c('Vagreement', {
    attrs: {
      "agreement": _vm.agreementnew
    },
    on: {
      "on-agreement-change": _vm.onAgreementChange
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "ewmShow"
  }, [_c('a', [_vm._v("关注微信")]), _c('div', {
    staticClass: "ewm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "r2list-button"
  }, [_c('i', {
    staticClass: "icon-mgame"
  }), _c('span', [_vm._v("魔力游戏")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a2ea3af","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 55
// module chunks = 70